export default __webpack_public_path__ + "static/Rubik-Medium-776429ebbc83ce850d796bdae5848fb4.ttf";